import React from "react";
import { TextBox, SelectBox, Switch, DataGrid } from "devextreme-react";
import { MasterDetail, Paging, Pager } from "devextreme-react/ui/data-grid";
import validaciones from "../../helpers/validaciones";

class PagedList extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      switchValue: false,
      direccion: "",
      region: "",
      pagedData: props.items,
      changed: 0,
    };

  }

  componentDidMount = () => {
    this.handleSearch()
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.items !== prevProps.items) {
      this.setState(() => ({
        pagedData: this.props.items,
      }))
    }
  }

  handleSearch = (e = {}) => {
    let dir = this.state.direccion;
    let reg = this.state.region;
    let valid = this.state.switchValue;

    switch (e.name) {
      case "direccion": {
        dir = e.value.toLowerCase();
        break;
      }
      case "region": {
        reg = e.value.toLowerCase();
        break;
      }
      case "valid": {
        valid = e.value;
        break;
      }
      default: break;
    }

    const filteredData = this.props.items.filter((x) => (
      (dir === "" || x.Direccion.toLowerCase().indexOf(dir) !== -1)
      && (reg === "" || x.Direccion.toLowerCase().indexOf(reg) !== -1)
      // && x.Valid !== valid
    ));

    this.setState(() => ({
      region: reg,
      direccion: dir,
      switchValue: valid,
      pagedData: filteredData,
    }));
  }

  render() {
    return (
      <React.Fragment>

        <div className="datos-empresa-filters">
          <TextBox
            placeholder="Buscar sucursal"
            mode="search"
            onValueChanged={(event) => this.handleSearch({ value: event.value, name: "direccion" })}
          />

          <SelectBox
            placeholder={this.props.selectPlaceHolder}
            items={[
              ...this.props.selectItems,
            ]}
            valueExpr="Text"
            showClearButton
            onSelectionChanged={(event) => this.handleSearch({ value: event.selectedItem ? event.selectedItem.Text : "", name: "region" })}
            displayExpr="Text"
          />

          {/* <div>
            No vigentes
            <Switch
              switchedOffText="No"
              switchedOnText="Si"
              value={this.state.switchValue}
              onValueChanged={(event) => this.handleSearch({ value: !this.state.switchValue, name: "valid" })}
            />
          </div> */}


        </div>

        <DataGrid
          showColumnHeaders={false}
          showBorders={false}
          showColumnLines={false}
          showRowLines={false}
          className="custom-table no-columns"
          onRowClick={this.props.itemClick}
          noDataText=""
          hoverStateEnabled
          onContentReady={(e) => {
            if (e.component.totalCount() === 0) {
              const config = {};
              config.addClass = "table-margin";
              const noDataSpan = e.component.element().querySelector(".dx-datagrid-nodata");
              const element = validaciones.noDataDOMElement(config, "Sin resultados");
              noDataSpan.appendChild(element);
            }
          }}
          dataSource={this.state.pagedData}
        >

          <MasterDetail
            enabled={false}
            autoExpandAll
            component={(props) => (
              <div className="notification-empresa-item">
                <div className="notification-text">
                  <span className="name">
                    {props.data.NombreCalle ? `${props.data.NombreCalle}` : " "}
                    {props.data.Numero ? `, ${props.data.Numero}` : " "}
                    {props.data.Comuna ? `, ${props.data.Comuna}` : ""}
                  </span>
                  <span className="details">{props.data.Region || ""}</span>
                </div>
                <i className="achs-icon icon">j</i>
              </div>
            )}
          />

          <Paging
            defaultPageSize={6}
          />

          <Pager
            showNavigationButtons
            showInfo
            infoText={(page, total) => `Página ${page} de ${total}`}
          />

        </DataGrid>


      </React.Fragment>
    );
  }
}

export default PagedList;
